import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

const History = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className="history-title-wrap" id="history">
        <h2>History</h2>
        <h3>
          플레이션은 신생 게임 개발 회사로서 걸어온 길과 주요 업적들을 연도별로 살펴보며,
          <br /> 앞으로도 계속해서 도약하는 모습을 보여드릴 것입니다.
        </h3>
      </div>
      <ul className="history-wrap">
        <li>
          <h4>2024년</h4>
          <ul>
            <li className="history-content">
              {isMobile ? (
                <>
                  <strong>06월</strong>
                  <div className="span-wrapper">
                    <span>충남글로벌게임센터 입주</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="span-wrapper">
                    <span>충남글로벌게임센터 입주</span>
                  </div>
                  <strong>06월</strong>
                </>
              )}
            </li>
            <li className="history-content">
              {isMobile ? (
                <>
                  <strong>03월</strong>
                  <div className="span-wrapper">
                    <span>법인설립</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="span-wrapper">
                    <span>법인설립</span>
                  </div>
                  <strong>03월</strong>
                </>
              )}
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default History;
